import React from 'react';

const BadgeIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 -1 22 35"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <g>
    <path d="M22,11c0-6.065-4.935-11-11-11S0,4.935,0,11c0,3.577,1.724,6.75,4.375,8.761l-3.503,9.178
      c-0.063,0.166-0.034,0.354,0.077,0.492s0.283,0.21,0.464,0.181l3.859-0.575l2.563,2.802C7.932,31.942,8.066,32,8.205,32
      c0.031,0,0.062-0.003,0.094-0.009c0.17-0.032,0.312-0.151,0.373-0.312l2.667-6.987l2.667,6.987c0.062,0.161,0.203,0.28,0.373,0.312
      C14.41,31.997,14.441,32,14.473,32c0.139,0,0.273-0.058,0.369-0.162l2.563-2.802l3.859,0.575c0.18,0.026,0.354-0.044,0.465-0.182
      c0.111-0.14,0.14-0.327,0.075-0.493l-3.704-9.549C20.482,17.368,22,14.36,22,11z M1,11C1,5.486,5.486,1,11,1s10,4.486,10,10
      s-4.486,10-10,10S1,16.514,1,11z M10,22.142l0.621,1.148l-2.685,7.274l-2.151-2.4c-0.112-0.121-0.248-0.181-0.421-0.156L2.1,28.496
      l3.117-8.153c1.494,0.927,3.042,1.503,4.896,1.621L10,22.138C10,22.139,10,22.141,10,22.142z M20.562,28.496l-3.271-0.488
      c-0.171-0.025-0.331,0.035-0.443,0.156l-2.196,2.4l-3.276-8.583c2.188-0.074,4.215-0.783,5.9-1.959L20.562,28.496z"/>
    <path d="M16.5,11c0-3.032-2.468-5.5-5.5-5.5S5.5,7.968,5.5,11s2.468,5.5,5.5,5.5S16.5,14.032,16.5,11z M6.5,11
      c0-2.481,2.019-4.5,4.5-4.5s4.5,2.019,4.5,4.5s-2.019,4.5-4.5,4.5S6.5,13.481,6.5,11z"/>
    </g>
  </svg>

);

export default BadgeIcon;
